import { IsInt,  IsOptional,  IsUUID,  Min } from 'class-validator'
import {  ApiPropertyOptional } from '@nestjs/swagger'

export class UpdateChapterTeachingDto {
  @ApiPropertyOptional({ type: 'string', description: 'ID du chapitre' })
  @IsOptional()
  @IsUUID('4')
  chapterId?: string

  @ApiPropertyOptional({ type: 'string', description: "ID de l'enseignement" })
  @IsOptional()
  @IsUUID('4')
  teachingId?: string

  @ApiPropertyOptional({ type: Number, description: 'Numéro d\'ordre' })
  @IsOptional()
  @IsInt()
  @Min(1)
  orderNumber?: number
}
